import styled from "styled-components";

export const LogisticDashboardWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1em;
  margin-bottom: 1em;
  justify-content: space-between;

  @media (max-width: 767px) {
    justify-content: center;
  }

  .DateSelect {
    display: flex;
    flex-flow: row nowrap;
    gap: 1em;

    @media (max-width: 767px) {
      flex-flow: column;
      width: 100%;

      .bbtn {
        width: 100%;
      }
    }
  }

  .DayPickerInput input {
    flex: 1 1 auto;
    outline: none;
    border-radius: 5px;
    border: 1px solid #9e9e9e !important;
    height: 100%;
    padding: 5px;

    @media (max-width: 767px) {
      width: 100%;
    }
    /* margin: 5px; */
  }

  .DayPickerInput-OverlayWrapper {
    z-index: 999;
  }
`;

export const LogisticDashboardTable = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-top: 2em;
  width: 100%;

  .logiTable {
    margin: 2em 0 4em 0;
  }

  .ant-table-content {
    box-shadow: var(--shadow);
  }

  .ant-ribbon {
    top: -24px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--accent);

    span {
      font-size: large;
    }
  }

  @media (max-width: 1023px) {
    width: 100%;
    max-width: 765px;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    max-width: 370px;
  }
`;

export const DashboardWrapperBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1em;
  margin: 2em 0;

  @media (max-width: 1300px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: 1023px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    width: 100% !important;
  }
`;

export const RunnerDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 1em;
  justify-content: center;
  align-items: center;
`;
